import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import mediaQueries from "../constants/mediaQueries";
import breakpoints from "../constants/breakpoints";
import { fadeIn } from 'react-animations';
 
const fadeAnimation = keyframes`${fadeIn}`;

const DropdownTitle = styled.div`
  position: relative;
  padding: 10px;
  /* border: 1px  #F58F29 solid; */
  color: black;
  font-family: "kanit", sans-serif;
  font-optical-sizing: auto;
  font-weight:300;
  font-style: normal;
  &:hover {
    border-radius: 10px;
    background: rgb(2,161,75);
    color: white;
    text-decoration: none;
  }
  @media ${mediaQueries.mediumDevices} {
    font-size: 14px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 16px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 17px;
  }
`;

const DropdownList = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px white solid;
  z-index: 1001;
  animation: 0.3s ${fadeAnimation};
  @media ${mediaQueries.mediumDevices} {
    width: 150px;
  }
  @media ${mediaQueries.largeDevices} {
    width: 200px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    width: 250px;
  }
`;

const DropdownListItem = styled.div`
  border: 1px white solid;
  padding: 5px;
  background:rgb(2,161,75);
  color: white;
  font-family: "kanit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 200;
  font-style: normal;
  /* opacity: 80%; */
  &:hover {
    background: #363636;
    color: white;
    text-decoration: none;
  }
  z-index: 1001;
  @media ${mediaQueries.mediumDevices} {
    font-size: 14px;
  }
  @media ${mediaQueries.largeDevices} {
    font-size: 15px;
  }
  @media screen and (min-width: ${breakpoints.extraLargeDevices}px) {
    font-size: 16px;
  }
`;

const DropdownHeader = ({ text, sections, link }) => {
  const [open, setOpen] = useState(false);
  if (link !== undefined) {
    return (
      <DropdownTitle as={Link} to={link}>
        {text}
      </DropdownTitle>
    );
  }
  const renderList = (array) => {
    return array.map(({ title, link }) => {
      return (
        <DropdownListItem as={Link} to={link} key={title}>
          {title}
        </DropdownListItem>
      );
    });
  };
  return (
    <DropdownTitle
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {text}
      {open && <DropdownList>{renderList(sections)}</DropdownList>}
    </DropdownTitle>
  );
};

export default DropdownHeader;
